import { Injectable, inject } from '@angular/core';

import { ClientConfigDBService } from '../db/client-config-db-service';

@Injectable()
export class PointToPointGroupMappingConfigResolver {
  private clientConfigDbService = inject(ClientConfigDBService);

  public resolve() {
    return this.clientConfigDbService.getPointToPointGroupMappingConfig();
  }
}
